import React from "react";
import DashboardLayout from "../../components/DashboardLayout";
import { Link } from "react-router-dom";
import { SettingsCard } from "../../components/pages/Settings/SettingsCard";
import FleetrifyActionDropdown from "../../components/Dropdown/SelectDrop/selectDropdown";
import { useCompanyDetailsControllers } from "../../controllers/useCompanyDetailsControllers";
import { FleetrifyButton } from "../../components/Button/customButton";
import { fleetrifyIcons } from "../../assets/icons/icons";
import DashboardMetrics from "../../components/Metrics/metrics";
import { companyDetails, companyDetailsData } from "../../utils/mock";
import { CompanyDetailsCard } from "../../components/pages/CompanyDetails/companyDetailsCard";
import CompanyBillingCard from "../../components/pages/CompanyDetails/companyBillingCard";
import CompanyServiceCard from "../../components/pages/CompanyDetails/companyServiceCard";
import { FLEETRIFYROUTEPATH } from "../../routes/routesPath";

const CompanyDetails = () => {
  const { actionOption, servicesData } = useCompanyDetailsControllers();
  return (
    <DashboardLayout
      title={
        <div>
          <div className="flex gap-1 items-center">
            <Link to={FLEETRIFYROUTEPATH.COMPANY} className="text-sm">
              Company
            </Link>
            <span>{">"}</span>
            <p>Company Details</p>
          </div>
        </div>
      }
      containerClass="space-y-10"
    >
      {/* <------- overview display------> */}
      <SettingsCard
        title="Overview"
        containerClassName="!h-fit"
        wrapClassName="space-y-14"
      >
        <div className="flex justify-between">
          <div className="flex items-center space-x-5">
            <div className="w-20 h-20 relative rounded-full bg-[#14388733] flex items-center justify-center text-[28px] font-bold text-[#143887]">
              <p>HL</p>
            </div>
            <div className="space-y-2">
              <p className="text-[20px] text-[#143887] font-bold">
                Hassan Enterpise
              </p>
              <p className="text-xs text-[#00032A]">User ID: #53767</p>
            </div>
          </div>
          <FleetrifyActionDropdown label="Action" items={actionOption} />
        </div>

        <div className="flex gap-3 items-center">
          <FleetrifyButton
            variant="outline"
            className="flex gap-2 items-center rounded-[16px] text-[#00032A] border border-[#00032A4D] py-[4px] px-[12px]"
          >
            {fleetrifyIcons.messageIcon}
            Send Message
          </FleetrifyButton>
          <FleetrifyButton
            variant="outline"
            className="flex gap-2 items-center rounded-[16px] text-[#00032A] border border-[#00032A4D] py-[4px] px-[12px]"
          >
            {fleetrifyIcons.mailIcon}
            Send Email
          </FleetrifyButton>
          <FleetrifyButton
            type="button"
            onClick={() => {}}
            className=" !py-[5px] rounded-3xl"
          >
            <Link to={FLEETRIFYROUTEPATH.COMPANY_BRANCHES}>
              View Company Branches
            </Link>
          </FleetrifyButton>
        </div>

        {/* <-------company metrics------> */}
        <DashboardMetrics
          metricCardClassName=" border-t border-l border-r"
          metrics={companyDetailsData.metrics}
        />
      </SettingsCard>

      <section className="flex w-full h-full space-x-5">
        <div className="w-2/3 h-full">
          <SettingsCard
            title="Basic Information"
            containerClassName="h-full"
            wrapClassName="h-full"
          >
            <CompanyDetailsCard company={companyDetails} />
          </SettingsCard>
        </div>

        <div className="w-1/3 flex flex-col h-full space-y-5">
          <div className="h-1/2">
            <SettingsCard title="Subscription Plan" containerClassName="h-full">
              <CompanyBillingCard
                plan="PREMIUM"
                price="₦120,000"
                billingCycle="Monthly"
                nextBillingDate="06th, June 2025"
                billingEmail="hassan.lamidi@gmail.com"
              />
            </SettingsCard>
          </div>

          <div className="h-1/2">
            <SettingsCard title="Services" containerClassName="h-full">
              <CompanyServiceCard services={servicesData} />
            </SettingsCard>
          </div>
        </div>
      </section>
    </DashboardLayout>
  );
};

export default CompanyDetails;
